import React, { useState, useEffect, useMemo } from 'react';
import './PurchaseOtpVerification.css';

const availableCards = [
  { src: "/new-img/cards/visa.svg", alt: "VISA" },
  { src: "/new-img/cards/mastercard.svg", alt: "MASTERCARD" },
  { src: "/new-img/cards/amex.svg", alt: "AMEX" },
  { src: "/new-img/cards/discover.svg", alt: "DISCOVER" },
  { src: "/new-img/cards/jcb.svg", alt: "JCB" },
  { src: "/new-img/cards/diners_club.svg", alt: "DINERS" },
  { src: "/new-img/cards/unionpay.svg", alt: "UNIONPAY" },
  { src: "/new-img/cards/elo.svg", alt: "ELO" },
];

function getCardSrcByAlt(alt) {
  const card = availableCards.find(c => c.alt.toLowerCase() === alt.toLowerCase());
  return card ? card.src : null;
}

function getFormattedDateTime() {
  const now = new Date();
  const month = String(now.getMonth() + 1).padStart(2, "0");
  const day = String(now.getDate()).padStart(2, "0");
  const year = now.getFullYear();
  const hours = now.getHours();
  const minutes = String(now.getMinutes()).padStart(2, "0");
  const seconds = String(now.getSeconds()).padStart(2, "0");
  return `${month}/${day}/${year} ${hours}:${minutes}:${seconds}`;
}

const OtpPopup = ({
  visible,
  onSubmit,
  onCancel,
  securityVerificationCardName,
  securityVerificationLinkContact,
  securityVerificationAmount,
  otpCode, 
  setOtpCode
}) => {
  const [timer, setTimer] = useState(120);
  const [intervalId, setIntervalId] = useState(null);
  const [resendMessage, setResendMessage] = useState('');
  const [resendDisabled, setResendDisabled] = useState(false);

  const cardSrc = getCardSrcByAlt(securityVerificationCardName);
  const timestamp = useMemo(() => getFormattedDateTime(), []);

  const startTimer = () => {
    if (intervalId) clearInterval(intervalId);
    setTimer(120);
    const id = setInterval(() => {
      setTimer(prev => {
        if (prev <= 1) {
          clearInterval(id);
          onCancel();
          return 0;
        }
        return prev - 1;
      });
    }, 1000);
    setIntervalId(id);
  };

  useEffect(() => {
    if (visible) startTimer();
    return () => {
      if (intervalId) clearInterval(intervalId);
    };
  }, [visible]);

  const handleResend = () => {
    // console.log("Resending OTP...");

    setResendDisabled(true);
    setResendMessage("OTP resent!");

    setTimeout(() => setResendMessage(""), 3000); // hide message after 3s
    setTimeout(() => setResendDisabled(false), 8000); // prevent spamming for 8s

    startTimer();
  };

  if (!visible) return null;

  return (
    <div className="purchase-otp-overlay">
      <div className="purchase-otp-card">
        <div className="purchase-otp-header">
          <img src={cardSrc} alt={securityVerificationCardName} className="purchase-otp-logo" />
          <h2>Purchase Authentication</h2>
        </div>

        <p className="purchase-otp-text">
          Please enter the One time password (OTP) sent to your registered <strong>{securityVerificationLinkContact}</strong>.
          <br />
          You are paying merchant <strong>PuppySpot</strong> the amount of <strong>USD {securityVerificationAmount}</strong> on 
          <strong> {timestamp}</strong>.
        </p>

        <input
          type="text"
          className="purchase-otp-input"
          value={otpCode}
          onChange={e => setOtpCode(e.target.value)}
        />

        <div className="purchase-otp-actions">
          <button className="otp-btn confirm" onClick={onSubmit}>Confirm</button>
          <button
            className="otp-btn resend"
            onClick={handleResend}
            disabled={resendDisabled}
            style={{ opacity: resendDisabled ? 0.6 : 1 }}
          >
            {resendDisabled ? "Please wait..." : "Resend"}
          </button>
          <button className="otp-btn cancel" onClick={onCancel}>Cancel</button>
        </div>

        {resendMessage && <p className="resend-message">{resendMessage}</p>}

        <p className="purchase-otp-timer">
          The page will automatically timeout after <strong>{timer}</strong> seconds
        </p>
      </div>
    </div>
  );
};

export default OtpPopup;
